import { compose, join, map, toPairs } from 'ramda';

export const startOrderUrl = compose(
  (params) => `/start-order?${params}`,
  join('&'),
  map(([x, y]) => `${x}=${y}`),
  toPairs
);
